import { render, staticRenderFns } from "./ficha-categoria-producto.vue?vue&type=template&id=1511a4e2"
import script from "./ficha-categoria-producto.vue?vue&type=script&lang=js"
export * from "./ficha-categoria-producto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports